import { render, staticRenderFns } from "./employerUserList.vue?vue&type=template&id=5d90e713&scoped=true"
import script from "./employerUserList.vue?vue&type=script&lang=js"
export * from "./employerUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d90e713",
  null
  
)

export default component.exports